export default page => {
  const { uid, layouts } = page;
  const result = {};

  for (const layoutUid in layouts) {
    const { groups } = layouts[layoutUid];
    for (const groupUid in groups) {
      const { shields } = groups[groupUid];
      for (const shieldId in shields) {
        result[shieldId] = { isMatrix: shields[shieldId].isMatrix, fileName: `${uid}-${shields[shieldId].shield_id}` };
      }
    }
  }

  return result;
};
